import React, { Component } from "react";
import Tooltip from "../../components/UI/TooltipIcon/TooptipIcon";
import orderBy from "lodash/orderBy";
import moment from "moment";
import { Link } from "react-router-dom";
import BottomScrollListener from "react-bottom-scroll-listener";
import placeholder from "./../../assets/toolkit-favorite-placeholder.svg";
import { isMobile, isMobileDevice } from "../../utils/deviceInfo";
import FooterBar from "../../components/FooterBar/FooterBar";
import rocket from "../../assets/onboarding/rocket.png";
import trending from "../../assets/trending.svg";
import toolkit from "../../assets/onboarding/toolkit.png";
import ww from "../../assets/onboarding/ww.png";
import welcome from "../../assets/onboarding/welcome.png";
import analytics from "../../assets/onboarding/analytics.png";
import officeCreatedIcon from "../../assets/office_created_icon.svg";
import {
  Modal,
  ModalBody,
  Button,
  Progress,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  Popover,
  PopoverHeader,
  PopoverBody,
  Row,
  Col,
  InputGroup,
  Input,
  InputGroupAddon,
  Collapse,
} from "reactstrap";
import { connect } from "react-redux";
import Select from "react-select";
import EmptyTable from "../../components/EmptyTable/EmptyTable";
import "rc-checkbox/assets/index.css";
import drillDownClose from "../../assets/drilldown_close.svg";
import stories from "../../assets/onboarding/Stories.png";
import welcomeStory from "../../assets/onboarding/wStory.svg";
import { storyTemplates, staticTitles, profilePicValidityCheck } from "../../utils/constants";
import CKEditorUI from "../../components/CKEditor/CKEditorUI";
import { MentionsInput, Mention } from "react-mentions";
import defaultCreateStory from "./defaultCreateStory";
import defaultMentionStyle from "./defaultMentionStyle";
import defaultUrlStyle from "./defaultUrlStyle";
import IntroStoriesModal from "./StoriesIntroModal.jsx";
import "./Stories.css";
import axios from "../../axios";
import * as url from "../../utils/url";
import * as actionCreators from "../../modules/actions/index";
import { capitalizeFirstLetter } from "../../utils/stringUtils";
import Loading from "../../hoc/Loading/Loading";
import { ListGroup, ListGroupItem } from "reactstrap";
import avatarIcon from "../../assets/default-avatar.png";
import Toggle from "react-toggle";
import ShowMore from "react-show-more";
import PlaceholderStories from "./PlaceholderStories";
import If from "../../components/Shared/If";
import classnames from "classnames";
import get from "lodash/get";
import filter from "lodash/filter";
import size from "lodash/size";
import StoryItems from "./StoryItems.jsx";
import StoryFilter from "./StoryFilter.jsx";
import Trending from "./TrendingOld.jsx";

import StoryItemsArchive from "./StoryItemsArchive.jsx";
import CreateStoryForm from "../../components/CreateStory/CreateStoryForm.jsx";

import {
  tools,
  filtersData,
  toolkitCategoryFilterMapping,
  getDisplayByKey,
  getTypeByKey,
  getAppliedFiltersCount,
  toolkitCategoryFilterValues,
  addToolStep,
  getSubcategories,
  UserRole,
} from "./../../utils/constants";

class Stories extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stories: [],
      url: "",
      list: [],
      storyType: {},
      originalStoryTotal: 0,
      skipValue: 0,
      archievedStories: [],
      privacy: "PUBLIC",
      organizationId: this.props.user.profile.organizationId._id,
      isAnonymous: false,
      isAnonymousVisible: true,
      selectedFilter: [],
      filters: [],
      topicsSelected: [{ name: "All" }],
      isRemoved: false,
      removedIntro: "Don't show this again",
      disableSubmit: true,
      showReplies: false,
      mentionsSelected: [],
      sentiment: null,
      suggest: [],
      isBadWords: false,
      sentimentColor: "",
      sentimentValue: "",
      mentionsFound: [],
      topicAlert: false,
      showArchived: false,
      isSentiment: true,
      isUrl: false,
      mentionWord: "",
      editStory: "",
      isEditStory: false,
      totalStories: 0,
      storyTopic: "all",
      description: {
        value: "",
        error: false,
      },
      topics: [],
      showIntro: !this.props.user.profile.hideIntro,
      // showIntro:this.props.user.profile.role==="Member" && this.props.user.profile.hideIntro!=true?true: false,
      mentionBool: false,
      mentionsIndex: 0,
      dropdownOpen: false,
      title: "",
      showCreateStoryModal: false,
      modalActionType: "Create",
      categoryDefinitionPopoverOpen: false,
      collapseCompleted: true,
      showRemoveFeedConfirmationModal: false,
      storyIdRemove: "",
      FilterSkipValue: 0,
      Filtermode: 0,
      ClearFiltermode: 0,
      Categoriesfilters: [],
      Tagsfilters: [],
      selectedCategoriesFiltercount: 0,
      selectedTagFilterccount: 0,
      searchedTerm: "",
      isFilterCollapsed: false,
      timerId: "",
      limit: 0,
      isApiLoading: false,
    };
  }

  toggleDropdown = id => {
    let { dropdownOpen } = this.state;
    if (dropdownOpen === id) {
      this.setState({ dropdownOpen: "" });
    } else {
      this.setState({ dropdownOpen: id });
    }
  };

  componentDidMount() {
    console.log("ARCHIVED -------");
    if (isMobile) {
      // console.log("testing MObile")
      this.props.updateNavBar({
        title: "Enterprise",
        hasBack: true,
        backButton: "<b>Back</b>",
        showNotification: true,
        className: null,
        isBreadCrumbs: false,
      });
      this.setState({ limit: 3 });
    } else {
      this.setState({ limit: 10 });
    }

    this.getStoryFeeds();
    this.getTopics();

    // this.props.history.location.pathname='/home/stories'
    this.setState({ url: this.props.match.url });

    const { kpiMasterList } = this.props.kpiMaster;
    const { mappingMasterList } = this.props.mappingMaster;
    const { organizationId } = this.props.user.profile;
    // console.log(this.props)
    if (kpiMasterList.length === 0) {
      axios.get(url.getKpiMaster).then(({ data }) => {
        const payload = data.data;
        this.props.onKpiMasterListFetched(payload);
      });
    }
    if (
      this.props.mappingMaster.length === 0 ||
      !mappingMasterList ||
      mappingMasterList.length === 0
    ) {
      axios
        .get(url.getExistingMappings(organizationId._id))
        .then(({ data }) => {
          const payload = data.data;
          this.props.onMappingMasterListFetched(payload.mapping);
        });
    }
  }

  getTopics = () => {
    let orgId = this.props.user.profile.organizationId._id;

    axios.get(url.getTopics(orgId)).then(({ data }) => {
      // console.log("data---", data.data)
      let topics = data.data;
      this.setState({
        topics: [...topics],
      });
    });
  };

  closeIntroModal = () => {
    this.setState({ showIntro: false });
    if (this.state.isRemoved) {
      this.props.onProfileUpdate({ hideIntro: true });
    }
  };

  neverShowIntro = () => {
    // console.log("delete this")
    // this.setState({
    //   removedIntro:"This message will no longer be shown.",
    //   isRemoved:true
    //   // showIntro:  false
    // })
    // this.setState({
    //   removedIntro:"This message will no longer be shown.",
    //   isRemoved:true
    //   // showIntro:  false
    // })
    axios.post(url.removeIntro).then(({ data }) => {
      // console.log("success")
      this.setState({
        removedIntro: "This message will no longer be shown.",
        isRemoved: true,
        // showIntro:  false
      });
      this.props.onProfileUpdate({ hideIntro: true });
      // console.log(this.props.user)
    });
  };

  getStoryFeeds = async res => {
    // console.log(window.location.pathname)
    //this function will be called if all filters is cleared
    // Filtermode is set as 0 to differentiate that no filters are selected and stories need to be appended when scrolling.
    // When set as 1 the stories based on filter result will be replaced
    this.setState({ Filtermode: 0 });
    // return
    let { skipValue, limit, isApiLoading } = this.state;
    console.log("skipValue---", skipValue);

    if (res && res.isSearchCleared == true) {
      skipValue = 0;
    }

    let orgId = this.props.user.profile.organizationId._id;
    const organizationId = orgId ? orgId : res.profile.organizationId._id;
    let limitValue = limit == 0 ? (isMobile ? 3 : 6) : limit;
    let value = "archived";
    const config = {
      headers: { Pragma: "no-cache" },
    };
    // axios.get(url.getStories(organizationId, value))
    if (isApiLoading == false) {
      this.setState({ isApiLoading: true });
      axios
        .get(url.getStories, {
          params: {
            organizationId,
            value,
            skipValue,
            limitValue,
          },
        })
        .then(async ({ data }) => {
          if (data && data.data) {
            const activeStories = filter(data.data.storyList, eachStory => {
              return eachStory.isDeleted === false;
            });
            // ClearFiltermode is for onload changes when a clear filter button is pressed or when All category is clicked or when all the filters are cleared CleaClearFiltermode is checked as 0 to replace the previous fetch results that was based on the filter and show maximum 10 stories as existing
            // When ClearFiltermode set as 1 the stories will be appended to the fetch results.
            console.log(
              "this.state.ClearFiltermod---",
              this.state.ClearFiltermod
            );

            console.log("stories--- ", data.data.storyList);

            if (this.state.ClearFiltermode == 0) {
              //Skip value increament by 10

              this.setState(prevState => ({
                stories:
                  res && res.isSearchCleared == true
                    ? [...data.data.storyList]
                    : [...prevState.stories, ...data.data.storyList],
                topicAlert: false,
                skipValue: prevState.skipValue + limit,
                profile: this.props.user.profile,
                totalStories: data.data.storyTotal,
                originalStoryTotal: data.data.storyTotal,
                ClearFiltermode: 1,
              }));
            } else {
              //While scroll down stories result append to stories state
              //Skip value increament by 10
              this.setState(prevState => ({
                stories:
                  res && res.isSearchCleared == true
                    ? [...data.data.storyList]
                    : [...prevState.stories, ...data.data.storyList],
                topicAlert: false,
                skipValue: prevState.skipValue + limit,
                profile: this.props.user.profile,
                totalStories: data.data.storyTotal,
                originalStoryTotal: data.data.storyTotal,
              }));
            }
            await this.setState({ isApiLoading: false });
          }
        });
    }
  };

  toggleDefinitionPopover = () =>
    this.setState({
      categoryDefinitionPopoverOpen: !this.state.categoryDefinitionPopoverOpen,
    });

  toggleCreateStory = e => {
    // console.log(e)
    this.setState({
      showCreateStoryModal: !this.state.showCreateStoryModal,
      storyType: e,
    });
  };

  closeCreateStoryModal = () => {
    this.setState({
      showCreateStoryModal: false,
      isAnonymous: false,
      topicsSelected: [{ name: "All" }],
      storyType: "",
      topicAlert: false,
      editStory: "",
      isEditStory: false,
      isAnonymous: null,
      description: { value: "" },
      suggest: [],
      sentiment: null,
    });
  };

  handleEditStory = story => {
    const {
      description,
      isAnonymous,
      privacy,
      title,
      mentionsSelected,
      topicsSelected,
    } = this.state;

    let newStory = { ...story };

    // console.log("edit---", newStory)
    // console.log(description, isAnonymous, privacy, title, mentionsSelected, topicsSelected)
    let desc = `<span>${description.value.replace(
      /<\/?![^>]+(>|$)/g,
      ""
    )}</span>`;
    let sanitizedDescription = {};
    let mentionsText = `<span>${description.value.replace(
      /<\/?![^>]+(>|$)/g,
      ""
    )}</span>`;
    sanitizedDescription.value = `${description.value.replace(
      /<\/?![^>]+(>|$)/g,
      ""
    )}`;
    sanitizedDescription.userReferences = [];
    // console.log(desc, '----mselect--->' ,mentionsSelected)
    let isMention = desc.indexOf("@") > -1 ? true : false;

    let desArr = desc.split(" ");

    let mArray = desArr.filter(e => {
      if (e.indexOf("@") > -1) {
        return e;
      }
    });
    // console.log(desc, '--desArr---', desArr,'----marr---', mArray)

    // console.log('----',mArray)
    let mentions = mentionsSelected.filter(e => {
      let valMention = `({ "_id": "${e._id}", "email": "${e.email}", "name": "${e.name}"})`;
      // console.log("---vMention ----", valMention)
      // let wLength = word.length
      if (desc.includes(valMention)) {
        // console.log(e, '---w----',word)
        let strReplace = `@[@${e.name}]({ "_id": "${e._id}", "email": "${e.email}", "name": "${e.name}"})`;
        // console.log(strReplace)
        desc = desc.replace(
          strReplace,
          `<a class="userMentionWord" href="/home/${this.props.user.profile.organizationId._id}/profile/${e._id}">@${e.name}</a>`
        );
        // console.log(desc)
        sanitizedDescription.value = sanitizedDescription.value.replace(
          strReplace,
          `@${e.name}`
        );
        sanitizedDescription.userReferences.push(e._id);
        isMention = true;
        // console.log("val-----", sanitizedDescription, desc)
        return e;
      }
    });

    if (desc.length > 0) {
      newStory.description = desc;

      if (isAnonymous) {
        newStory.isAnonymous = isAnonymous;
      } else if (isAnonymous === undefined) {
        newStory.isAnonymous = false;
      }

      if (mentions && mentions.length > 0) {
        newStory.users = mentions;
      }
      // payload.parent=item._id
      newStory.isMention = isMention;
      newStory.sanitizedDescription = sanitizedDescription;
      newStory.mentionsText = mentionsText;
      newStory.template = this.state.storyType;
      newStory.topics = topicsSelected.filter(e => e.name !== "All");
      // console.log('modified story----', newStory)
    }
    // axios.post(url.editStory(item._id), payload).then(({ data }) => {

    //   this.setState({
    //     description: "",
    //     title: "",
    //     privacy: true,
    //     isAnonymous: false,
    //     mentionsSelected: [],
    //     mentionsFound: [],
    //     mentionWord:"",
    //     showReplies:false,
    //     topicsSelected:[],
    //     storyType:""
    //   });

    //   this.getStoryFeeds();

    // })
  };

  handleCreateStory = () => {
    const {
      description,
      isAnonymous,
      privacy,
      title,
      mentionsSelected,
      topicsSelected,
    } = this.state;
    // const { item } = this.props

    let dValue =
      description && description.value
        ? description.value
            .replace(/<\/?![^>]+(>|$)/g, "")
            .replace(/[\. ,:-]+/g, "")
        : 0;

    var Filter = require("bad-words"),
      filter = new Filter();
    filter.addWords("suck", "shit");
    filter.removeWords("sex");
    // console.log('dval----', dValue)
    let isUrl;
    let cleanDesc = description.value ? filter.clean(description.value) : false;

    // return
    if (dValue.length > 0 && cleanDesc === description.value) {
      let desc = `<span> ${description.value.replace(
        /<\/?![^>]+(>|$)/g,
        ""
      )} </span>`;
      let sanitizedDescription = {};
      let mentionsText = `<span>${description.value.replace(
        /<\/?![^>]+(>|$)/g,
        ""
      )}</span>`;
      sanitizedDescription.value = `${description.value.replace(
        /<\/?![^>]+(>|$)/g,
        ""
      )}`;
      sanitizedDescription.userReferences = [];
      // console.log(desc, '----mselect--->' ,mentionsSelected)
      let isMention = desc.indexOf("@") > -1 ? true : false;

      let desArr = desc.split(" ");

      let mArray = desArr.filter(e => {
        if (e.indexOf("@") > -1) {
          return e;
        }
      });
      // console.log(desc, '--desArr---', desArr,'----marr---', mArray)

      // console.log('----',mArray)
      let mentions = mentionsSelected.filter(e => {
        let valMention = `({ "_id": "${e._id}", "email": "${e.email}", "name": "${e.name}"})`;
        // console.log("---vMention ----", valMention)
        // let wLength = word.length
        if (desc.includes(valMention)) {
          // console.log(e, '---w----',word)
          let strReplace = `@[@${e.name}]({ "_id": "${e._id}", "email": "${e.email}", "name": "${e.name}"})`;
          // console.log(strReplace)
          desc = desc.replace(
            strReplace,
            `<a class="userMentionWord" href="/home/${this.props.user.profile.organizationId._id}/profile/${e._id}">@${e.name}</a>`
          );
          // console.log(desc)
          sanitizedDescription.value = sanitizedDescription.value.replace(
            strReplace,
            `@${e.name}`
          );
          sanitizedDescription.userReferences.push(e._id);
          isMention = true;
          return e;
        }
      });

      // if ( desc.indexOf("www")>-1 && desc.indexOf("http")==-1){
      //   desc = desc.replace(/(www[^\s]+)/g,`<a class="urlLink" href='${'https:\/\/'}$1' target='_blank' >$1</a>`)
      //   isUrl=true
      // }

      // if(desc.indexOf("http")>-1 || desc.indexOf("www")>-1){
      //   desc = desc.replace(/((http|https)?:\/\/[^\s]+)/g,`<a class="urlLink" href='$1' target='_blank' >$1</a>`)
      //   desc = desc.replace(/(www[^\s]+)/g,`<a class="urlLink" href='${'https:\/\/'}$1' target='_blank' >$1</a>`)
      //   console.log(desc)
      //   isUrl=true
      // }

      let splitDesc = desc.split(" ").map(e => {
        let val = e;
        if (e.indexOf("http") > -1 && e.indexOf("www") == -1) {
          isUrl = true;
          val = e.replace(
            /((http|https)?:\/\/[^\s]+)/g,
            `<a class="urlLink" href='$1' target='_blank' >$1</a>`
          );
        } else if (e.indexOf("www") > -1 && e.indexOf("http") == -1) {
          isUrl = true;
          val = e.replace(
            /(www[^\s]+)/g,
            `<a class="urlLink" href='${"https://"}$1' target='_blank' >$1</a>`
          );
        } else if (e.indexOf("www") > -1 && e.indexOf("http") > -1) {
          isUrl = true;
          val = e.replace(
            /((http|https)[^\s]+)/g,
            `<a class="urlLink" href='$1' target='_blank' >$1</a>`
          );
        }
        return val;
      });

      desc = splitDesc.join(" ");
      // if ( desc.indexOf("www")>-1 && desc.indexOf("http")>-1){
      //   desc = desc.replace(/((http|https):\/\/www[^\s]+)/g,`<a class="urlLink" href='$1' target='_blank' >$1</a>`)
      //   isUrl=true
      // }

      // console.log(desc)
      // return
      if (desc.length > 0) {
        let payload = { description: desc, title, isAnonymous, privacy };
        if (isAnonymous) {
          payload.isAnonymous = isAnonymous;
        } else if (isAnonymous === undefined) {
          payload.isAnonymous = false;
        }
        if (mentions && mentions.length > 0) {
          payload.users = mentions;
        }
        payload.isUrl = isUrl;
        // payload.parent=item._id
        payload.isMention = isMention;
        payload.sanitizedDescription = sanitizedDescription;
        payload.mentionsText = mentionsText;
        payload.template = this.state.storyType;
        payload.topics = topicsSelected.filter(e => e.name !== "All");
        payload.isMobile = isMobileDevice;
        // console.log(payload)
        // return

        axios.post(url.createStory, payload).then(({ data }) => {
          // this.props.addStoryCount({story: "add"});

          this.setState({
            description: "",
            title: "",
            privacy: true,
            isAnonymous: false,
            mentionsSelected: [],
            mentionsFound: [],
            mentionWord: "",
            topicAlert: false,
            showReplies: false,
            topicsSelected: [{ name: "All" }],
            storyType: "",
            suggest: [],
            sentiment: null,
          });

          this.getStoryFeeds();
        });

        this.setState({
          showCreateStoryModal: false,
          description: "",
          title: "",
          privacy: true,
          topicsSelected: [],
        });
      } else {
        this.setState({ showCreateStoryModal: true });
      }
    } else {
      if (cleanDesc !== description.value && description.value.length > 0) {
        this.setState({ isBadWords: true });
      }
    }
  };

  onStoryPublish(story) {
    console.log("testing---", story);
    let { stories } = this.state;
    stories = [story, ...stories];
    this.setState(prevState => ({
      stories,
      totalStories: prevState.totalStories + 1,
      originalStoryTotal: prevState.originalStoryTotal + 1,
      showCreateStoryModal: false,
    }));
  }

  handleKeyPress = e => {
    let { mentionWord, description } = this.state;
    let char = e.key;
    let name = mentionWord.replace("@", "") + e.key;

    // console.log(e.key, e.charCode, e.keyCode)
    if (e.key !== "Shift" && e.key !== "Meta") {
      //  console.log('inside --- ', e.key)
      if (e.key === "@") {
        this.setState({ mentionWord: char });
      }

      if (e.key !== " " && mentionWord.length > 0) {
        this.setState(prevState => ({
          mentionWord: prevState.mentionWord + char,
        }));
        this.findUser(name);
      }

      if (
        mentionWord.length > 0 &&
        (e.key === " " || description.value.indexOf(mentionWord) < -1)
      ) {
        this.setState({
          mentionWord: "",
          mentionsFound: [],
        });
      }
      if (e.key === "Enter") {
        this.handleCreateStory();
      }
    }

    if (e.key === "Backspace" && mentionWord.length > 0) {
      let name = mentionWord.slice(0, mentionWord.length - 1);
      this.setState({ mentionWord: name });
      this.findUser(name);
    }
  };

  handleChangeStoryDescription = event => {
    let descriptionContext = event.target.value;
    // var Filter = require('bad-words'),
    // filter = new Filter();
    // filter.addWords('suck', 'shit');
    // console.log("INSIDE CHANGE STORY----")
    // let descriptionContext = event.editor.getData();
    // console.log(descriptionContext)
    // let {mentionBool, tempIndex, mentionsIndex}=this.state
    let valCheck = event.target.value
      .replace(/<\/?![^>]+(>|$)/g, "")
      .replace(/[\. ,:-]+/g, "")
      .replace(/^\n|\n$/g, "");
    // console.log("descriptionContext---", descriptionContext.replace(/[.,]/g, ''))
    // let sentimentText = descriptionContext.replace(/[.,]/g, '').replace(/\\/g, '')
    // if(!sentimentText.length>0){
    //   this.setState({
    //     sentiment: null,
    //     suggest: []
    //   })
    // }

    // let cleanDesc = filter.clean(descriptionContext)

    this.setState({
      description: { value: descriptionContext },
      disableSubmit: valCheck.length === 0,
      // isBadWords: !(cleanDesc===descriptionContext),
      // isText: descriptionContext.length>0?true:false
    });
    //  this.setState({isBadWords:false})

    //  let cleanDesc = filter.clean(descriptionContext)

    // if(descriptionContext.length>0){

    // axios.post(url.getSentiment, {text:sentimentText}).then( ({data}) => {
    //   // console.log(descriptionContext,'---data---',data.data)

    //   this.setState({
    //     sentiment: data.data.sentiment.ratio,
    //     suggest: data.data.suggest
    //   })
    //   this.renderProgress()
    //   // this.renderSuggestion()
    // })
    // }
    // else {
    //   if(cleanDesc!==descriptionContext && descriptionContext.length>0){
    //     this.setState({isBadWords:true, disableSubmit:true})
    //   }

    // }
  };

  selectUserMention = val => {
    let name = val.name.replace(/ /g, "_");
    // .replace(" ", "_")

    let text = this.state.description.value + name;
    // let removeLett/er = text.lastIndexOf("@")+1
    // text = text.replace()
    // console.log(val.name, name, text)
    // name is correct

    let replaceM = text.lastIndexOf("@") + 1;
    let str1 = text.slice(replaceM);
    let spaceI = str1.indexOf(" ") + 1;
    let diffW = str1.length - name.length;
    let str2 = str1.slice(diffW);
    str1 = str1.slice();
    // console.log(replaceM, str1,str2)

    text = text.replace(str1, str2);
    // console.log('text 2 - ',text)
    // console.log(text)
    this.setState(prevState => ({
      mentionsFound: [],
      mentionWord: "",
      description: { value: text },
      mentionsSelected: [...prevState.mentionsSelected, val],
    }));
  };

  findUser = name => {
    // console.log('name -- ', name)
    name = name.replace("@", "").replace("Shift", "").replace("Meta", "");
    if (name.length > 0) {
      axios.get(url.findUser(name)).then(({ data }) => {
        // let response = data.data
        let response = data.data.map(e => {
          let obj = {
            name: e.firstName + " " + e.lastName,
            _id: e._id,
            email: e.email,
          };
          return obj;
        });
        // console.log(response)
        this.setState(prevState => ({
          mentionsFound: [...response],
        }));
      });
    }
  };

  handleKeyPressDelete = e => {
    let { mentionWord, description } = this.state;
    let char = e.key;
    let name = mentionWord.replace("@", "") + e.key;
    // console.log(e.key, e.charCode, e)
    if (e.key === "Backspace") {
      let name = mentionWord.slice(0, mentionWord.length - 1);
      this.setState({ mentionWord: name });
      this.findUser(name);
    }
  };

  handlePermissionChange = changeEvent => {
    this.setState({
      isAnonymous: changeEvent.target.checked,
    });
  };

  showSentiment = () => {
    this.setState(prevState => ({ isSentiment: !prevState.isSentiment }));
  };

  archiveStory = id => {
    let { stories } = this.state;
    const filteredStories = stories.filter(e => e._id !== id);

    axios.put(url.archiveStory(id)).then(data => {
      // this.getStoryFeeds();
      this.setState(prevState => ({
        dropdownOpen: false,
        stories: [...filteredStories],
        totalStories: prevState.totalStories - 1,
        originalStoryTotal: prevState.originalStoryTotal - 1,
      }));
    });
  };

  deArchiveStory = id => {
    let { stories } = this.state;
    // stories = {...stories, item}
    const filteredStories = stories.filter(e => e._id !== id);

    axios.put(url.deArchiveStory(id)).then(data => {
      // this.getStoryFeeds();
      const result = data;
      this.setState(prevState => ({
        dropdownOpen: false,
        stories: [...filteredStories],
        totalStories: prevState.totalStories - 1,
        originalStoryTotal: prevState.originalStoryTotal - 1,
      }));
    });
  };

  removeStoryFeeds = (id, type) => {
    let { stories } = this.state;
    this.setState({ showRemoveFeedConfirmationModal: false });
    const filteredStories = stories.filter(e => e._id !== id);

    axios.put(url.removeStoryFeeds(id)).then(resp => {
      if (resp.data.data.parentStory && resp.data.data.parentStory.item) {
        this.showStoryComments(resp.data.data.parentStory.item);
      }
      this.setState(prevState => ({
        dropdownOpen: false,
        stories: { ...filteredStories },
        totalStories: prevState.totalStories - 1,
        originalStoryTotal: prevState.originalStoryTotal - 1,
      }));
    });
  };

  showStoryComments = item => {
    // console.log(item)
    axios.get(url.getStoryComments(item)).then(({ data }) => {
      // this.getStoryFeeds();
      // console.log(data)
      let arr = data.data.storyList;
      this.setState({
        showResponses: [...arr],
      });
    });
  };

  showStoryRemoveConfirmation = storyId => {
    // console.log(storyId)
    this.setState({
      showRemoveFeedConfirmationModal:
        !this.state.showRemoveFeedConfirmationModal,
      storyIdRemove: storyId,
    });
  };

  closeStoryRemoveConfirmation = storyId => {
    this.setState({
      showRemoveFeedConfirmationModal: false,
      storyIdRemove: "",
    });
  };

  createMarkup = input => {
    // console.log(input)
    return { __html: `<div>${input}</div>` };
  };

  createResponse = () => {
    this.setState(prevState => ({ showReplies: !prevState.showReplies }));
  };

  editStory = story => {
    if (story.template && story.template._id) {
      let storyName = storyTemplates.filter(
        e => e._id === story.template._id
      )[0];
      // console.log(storyTemplates,'----------->',story)
      this.setState(prevState => ({
        showCreateStoryModal: true,
        storyType: storyName,
        editStory: story,
        isEditStory: true,
        topicsSelected: [...story.topics, ...prevState.topicsSelected],
        isAnonymous: story.isAnonymous,
        description: {
          value: story.mentionsText.replace(/<\/?span[^>]*>/g, ""),
        },
      }));
    } else {
      this.setState({
        showCreateStoryModal: true,
        storyType: "No template",
      });
    }
  };
  //This function use to enable or disable isFilterCollapsed state
  //For 'filter div' toggle purpose (show/hide)
  //this function will be called by Filters, Clear Filter button onclick event
  toggleCollapse = () => {
    const { isFilterCollapsed } = this.state;
    this.setState({
      isFilterCollapsed: !isFilterCollapsed,
    });
  };

  //This function fetch tags value and store selected tags array value
  //set filter mode if filter mode is 1 the filter mode is enabled
  //define FilterSkipValue as 0 , this skip value used in backend for pagination purpose
  //if selected value is not equal to "all" set state and call getStoryFilterFeeds (common filter api function)
  //if selected value is "all" ,
  //a) clear state and check any filter is activated
  //b) if no, call getStoryFilterFeeds or call handleClearFilters function

  filterTopic = async topic => {
    await this.setState({ FilterSkipValue: 0, Filtermode: 1 });
    let name = topic.code ? topic.code : topic;
    let {
      filters,
      selectedFilter,
      filteredStories,
      originalStoryTotal,
      selectedCategoriesFiltercount,
    } = this.state;
    const list = orderBy(this.state.stories, "createdOn", "desc");
    let list2 = list.map(a => ({ ...a }));
    let sfilter = selectedFilter.map(a => a);

    if (name !== "all") {
      if (filters.indexOf(name) > -1) {
        sfilter = sfilter.filter(e => e !== name);

        await this.setState(prevState => ({
          filters: filters.filter(e => e !== name),
          selectedFilter: selectedFilter.filter(e => e !== name),
          selectedCategoriesFiltercount:
            prevState.selectedCategoriesFiltercount - 1,
        }));
      } else {
        sfilter = [sfilter, name];

        await this.setState(prevState => ({
          filters: [...prevState.filters, name],
          selectedFilter: [...prevState.selectedFilter, name],
          selectedCategoriesFiltercount:
            prevState.selectedCategoriesFiltercount + 1,
        }));
      }

      let fList = list2.filter(item => {
        let itemTopic =
          item.topics && item.topics.length > 0
            ? item.topics.map(e => e.code)
            : [];
        let template = item.template ? item.template._id : "";
        itemTopic.push(template);
        let dup = itemTopic.concat(sfilter);
        let set1 = new Set(dup);
        if (sfilter.length > 0) {
          if (dup.length > set1.size) {
            return item;
          }
        } else {
          return item;
        }
      });

      if (fList) {
        await this.setState({ totalStories: fList.length });
      }
      clearTimeout(this.state.timerId);
      let callfunction = this;
      this.state.timerId = setTimeout(function () {
        callfunction.getStoryFilterFeeds();
      }, 1000);
    } else {
      let { stories } = this.state;
      await this.setState(prevState => ({
        filters: [],
        selectedFilter: [],
        totalStories: originalStoryTotal,
        selectedCategoriesFiltercount: 0,
      }));
      if (
        this.state.searchedTerm.length != 0 ||
        this.state.filters.length != 0 ||
        this.state.Tagsfilters.length != 0
      ) {
        this.getStoryFilterFeeds();
      } else {
        await this.setState({ stories: [], FilterSkipValue: 0 });
        this.handleClearFilters();
      }
    }
  };
  //filter tag function select categories filter value in array
  //set the filter skip value and filter value
  //if selected value is not 'all', store selected value and selected count in state, and call getStoryFilterFeeds function (common filter api function)
  //if selected value is "all" ,
  //a) clear state and check any filter is activated
  //b) if no, call getStoryFilterFeeds or call handleClearFilters function
  filterbyTag = async tag => {
    await this.setState({ FilterSkipValue: 0, Filtermode: 1 });
    if (tag !== "all") {
      let tag_id = tag._id ? tag._id : tag;
      let { Tagsfilters } = this.state;
      let { filters } = this.state;
      let { searchedTerm, FilterSkipValue } = this.state;

      if (Tagsfilters.indexOf(tag_id) > -1) {
        await this.setState(prevState => ({
          Tagsfilters: Tagsfilters.filter(e => e !== tag_id),
          selectedTagFilterccount: prevState.selectedTagFilterccount - 1,
        }));
      } else {
        if (this.state.Tagsfilters.length > 0) {
          await this.setState(prevState => ({
            Tagsfilters: [...prevState.Tagsfilters, tag_id],
            selectedTagFilterccount: prevState.selectedTagFilterccount + 1,
          }));
        } else {
          await this.setState(prevState => ({
            Tagsfilters: [tag_id],
            selectedTagFilterccount: prevState.selectedTagFilterccount + 1,
          }));
        }
      }

      let { skipValue } = this.state;
      let organizationId = this.props.user.profile.organizationId._id;
      let tag_filter = this.state.Tagsfilters;
      let category_filters = this.state.filters;
      let searchedTerm_text = this.state.searchedTerm;
      let value = "all";
      clearTimeout(this.state.timerId);
      let callfunction = this;
      this.state.timerId = setTimeout(function () {
        callfunction.getStoryFilterFeeds();
      }, 1000);
    } else {
      await this.setState(prevState => ({
        Tagsfilters: [],
        selectedTagFilterccount: 0,
        FilterSkipValue: 0,
      }));
      if (
        this.state.searchedTerm.length != 0 ||
        this.state.filters.length != 0 ||
        this.state.Tagsfilters.length != 0
      ) {
        this.getStoryFilterFeeds();
      } else {
        await this.setState({ stories: [], FilterSkipValue: 0 });
        this.handleClearFilters();
      }
    }
  };

  //getStoryFilterFeeds function is commom filter api call function
  //its call getStoriesbyfilter node js backend api function, output return maximum 10 results based on input params value
  //Here we checked Filtermode condition
  //a) if Filtermode is 1 : set state stories to first 10 records, skip value
  //b) if Filtermode is 0 : append stories values in state

  async getStoryFilterFeeds() {
    let organizationId = this.props.user.profile.organizationId._id;
    let tag_filter = this.state.Tagsfilters;
    let category_filters = this.state.filters;
    const { FilterSkipValue, filters, searchedTerm, limit, isApiLoading } =
      this.state;
    let params = {
      organizationId: organizationId,
      tag_filter: tag_filter,
      category_filters: category_filters,
      searchedTerm: searchedTerm,
      skipValue: FilterSkipValue,
      limitValue: limit,
      value: "archived",
    };
    if (isApiLoading == false) {
      await this.setState({ isApiLoading: true });
      axios
        .get(url.getStoriesbyfilter, {
          params: params,
        })
        .then(async ({ data }) => {
          await this.setState({ isApiLoading: false });
          if (data && data.data) {
            const activeStories = filter(data.data.storyList, eachStory => {
              return eachStory.isDeleted === false;
            });
            if (this.state.FilterSkipValue == 0) {
              this.setState({ stories: [] });
            }

            if (this.state.Filtermode == 1) {
              await this.setState(prevState => ({
                stories: [...data.data.storyList],
                topicAlert: false,
                FilterSkipValue: prevState.FilterSkipValue + limit,
                profile: this.props.user.profile,
                totalStories: data.data.storyTotal,
                originalStoryTotal: data.data.storyTotal,
                Filtermode: 0,
                ClearFiltermode: 0,
              }));
            } else {
              await this.setState(prevState => ({
                stories: [...prevState.stories, ...data.data.storyList],
                topicAlert: false,
                FilterSkipValue: prevState.FilterSkipValue + limit,
                profile: this.props.user.profile,
                totalStories: data.data.storyTotal,
                originalStoryTotal: data.data.storyTotal,
                ClearFiltermode: 0,
              }));
            }
          }
        });
    }
  }
  //This function use for clear filter related state and call getStoryFeeds and getTopics
  //to get result from getStoryFeeds (common onload function for getting stories) && getTopics function (its return topic result based on user id)

  async handleClearFilters(val) {
    let { stories, originalStoryTotal, searchedTerm } = this.state;
    this.setState(prevState => ({
      skipValue: 0,
      FilterSkipValue: 0,
      filters: [],
      selectedFilter: [],
      Tagsfilters: [],
      selectedCategoriesFiltercount: 0,
      selectedTagFilterccount: 0,
      totalStories: originalStoryTotal,
      searchedTerm: "",
      Filtermode: 0,
      ClearFiltermode: 0,
    }));
    this.getStoryFeeds(val);
    if (val && !isMobile) {
      this.getTopics();
    }
  }
  //This function use to get search keyword filter value and store to searchedTerm state
  //if search value is not null set 1 sec loading timer and  call getStoryFilterFeeds
  //if three filter is empty (search, tag, category) clear filterskipvalue and onload skip value and call handleClearFilters
  handleSearchQueryChanged = async event => {
    this.setState({
      searchedTerm: event.target.value,
      FilterSkipValue: 0,
      SkipValue: 0,
      ClearFiltermode: 0,
      Filtermode: 1,
    });
    let targetValue = event.target.value;
    let tag_filter = this.state.Tagsfilters;
    let category_filters = this.state.filters;
    if (targetValue != "") {
      clearTimeout(this.state.timerId);
      let callfunction = this;
      this.state.timerId = setTimeout(function () {
        callfunction.getStoryFilterFeeds();
      }, 1000);

      // return a function which will cancel the timer
    } else if (
      targetValue.length == 0 &&
      tag_filter.length == 0 &&
      category_filters.length == 0
    ) {
      this.setState({ FilterSkipValue: 0, skipValue: 0 });
      this.handleClearFilters({ isSearchCleared: true });
    } else {
      this.getStoryFilterFeeds();
    }
  };
  //this function is called when page scroll event,
  //it will handle two function  getStoryFeeds, getStoryFilterFeeds , this two function return stories result from backend api call
  //if any filter is active or not
  //a) if any filter is active and skip value less than stories count call getStoryFilterFeeds function ,
  //1) if Filtermode 1 : it will store filter result to stories state
  //2) if Filtermode 0 : it will append filter result  to stories state
  //if check no filter is active and and skip value less than stories count call getStoryFeeds function ,
  //1. if ClearFilter mode 0 : it will store result to stories state
  //1. if ClearFilter mode 1 : it will append result to stories state
  handleOnDocumentBottom = async () => {
    let {
      totalStories,
      skipValue,
      filters,
      Tagsfilters,
      searchedTerm,
      FilterSkipValue,
      limit,
    } = this.state;
    if (
      filters.length > 0 ||
      Tagsfilters.length > 0 ||
      searchedTerm.length > 0
    ) {
      if (FilterSkipValue < totalStories && totalStories > limit) {
        this.getStoryFilterFeeds();
      }
    } else {
      if (skipValue < totalStories && totalStories > limit) {
        this.getStoryFeeds();
      }
    }
    if (this.props.alertOnBottom) {
      alert(
        'Bottom of this container hit! Too slow? Reduce "debounce" value in props'
      );
    }
  };

  renderStories = () => {
    // console.log("stories ---")
    const isAdmin =
      this.props.user.profile.role === "Admin" ||
      this.props.user.profile.role === "SuperAdmin";
    let list = orderBy(this.state.stories, "createdOn", "desc");
    const { orgAdmin } = this.props.user.profile;
    const { description, selectedFilter } = this.state;
    let filters = this.state.topics;

    // console.log(selectedFilter,"--topics , filters)

    let fList = list.filter(item => {
      // console.log(item)
      let itemTopic =
        item.topics && item.topics.length > 0
          ? item.topics.map(e => e.code)
          : [];

      let template = item.template ? item.template._id : "";
      itemTopic.push(template);
      let dup = itemTopic.concat(selectedFilter);
      let set1 = new Set(dup);
      if (selectedFilter.length > 0) {
        if (dup.length > set1.size) {
          return item;
        }
      } else {
        return item;
      }
    });
    // console.log('flist---', fList)

    if (fList && fList.length > 0) {
      if (fList && fList.length && filters && filters.length > 0) {
        return fList.map((item, idx) => {
          const actionType = item.isDeleted ? "Restore" : "Archive";
          let avatar = item.isAnonymous
          ? avatarIcon
          : profilePicValidityCheck(item.profilePic) ? item.profilePic :null || avatarIcon;
          if (selectedFilter.length > 0) {
            return (
              <StoryItems
                showCreateStory={() => this.editStory(item)}
                removeStoryFeeds={this.removeStoryFeeds}
                deArchiveStory={this.deArchiveStory}
                archiveStory={this.archiveStory}
                filters={filters}
                getStoryFeeds={this.getStoryFeeds}
                showStoryRemoveConfirmation={this.showStoryRemoveConfirmation}
                key={item._id + idx}
                item={item}
                actionType={actionType}
                avatar={avatar}
                description={description}
              />
            );
          } else {
            return (
              <StoryItems
                showCreateStory={() => this.editStory(item)}
                removeStoryFeeds={this.removeStoryFeeds}
                deArchiveStory={this.deArchiveStory}
                archiveStory={this.archiveStory}
                filters={filters}
                getStoryFeeds={this.getStoryFeeds}
                showStoryRemoveConfirmation={this.showStoryRemoveConfirmation}
                key={item._id + idx}
                item={item}
                actionType={actionType}
                avatar={avatar}
                description={description}
              />
            );
          }
        });
      } else {
        return (
          <EmptyTable
            title="No results found"
            subtitle="Try changing your filters"
          />
        );
      }
    } else {
      return (
        <div className="noStories">
          <div className="mt20 trendingEmpty">
            <img src={placeholder} />

            <span className="noStoriesContent">
              There are currently no archived stories.
            </span>
          </div>
        </div>
      );
    }
  };

  countStories = list => {
    this.setState({ totalStories: list.length });
  };

  renderArchivedStories = () => {
    // const isAdmin = this.props.user.profile.role === 'Admin' || this.props.user.profile.role === 'SuperAdmin';
    // // const list = orderBy(this.state.archievedStories, "createdOn", "desc");
    // const { description,selectedFilter } = this.state;
    // let filters = this.state.topics
    // if (list && list.length > 0) {
    //   return list.map((item, idx) => {
    //     const actionType = item.isDeleted ? 'Restore' : 'Archive';
    //     const avatar = item.isAnonymous ? avatarIcon : item.profilePic || avatarIcon;
    //     return <StoryItems isArchived={true} showCreateStory={()=>this.editStory(item)} filters={filters} getStoryFeeds={this.getStoryFeeds} showStoryRemoveConfirmation={this.showStoryRemoveConfirmation} key={item._id+idx} item={item} actionType={actionType} avatar={avatar} description={description} />
    //   });
    // } else {
    //     return (
    //       <div>
    //         <div className="mt20 trendingEmpty">
    //         <img src={placeholder}/>
    //         <span className="noStoriesContent">
    //           No archived stories.
    //         </span>
    //         </div>
    //       </div>
    //     )
    // }
    // return null;
  };

  fetchUsers = (query, callback) => {
    if (!query) return;
    axios
      .get(url.findUser(query))
      .then((resp, idx) =>
        resp.data.data.map(user => ({
          display: "@" + user.firstName + " " + user.lastName,
          id: `{ "_id": "${user._id}", "email": "${user.email}", "name": "${
            user.firstName + " " + user.lastName
          }"}`,
          // {_id:user._id, email: user.email, idx},
          // name: user.firstName + " " + user.lastName,
          // _id: user._id,
          // email: user.email,
        }))
      )
      .then(callback);
  };

  addUrl = (query, callback) => {
    if (!query) return;
    // console.log('URL ----')
  };

  getStoriesCount = () => {
    const filteredStories = this.state.stories.filter(
      story => !story.isDeleted
    );
    this.setState({ totalStories: filteredStories.length });
    // return filteredStories.length
  };

  handleCollapse = () => {
    // console.log("collapse archive ---- 100% height")
    this.setState(prevState => ({
      collapseCompleted: !prevState.collapseCompleted,
    }));
  };

  selectUserMention = val => {
    // console.log(val)
    // console.log(val.toString(), typeof val, JSON.parse(val))
    let obj = JSON.parse(val);
    // console.log(obj)

    this.setState(prevState => ({
      mentionsFound: [],
      mentionWord: "",
      // description: {value: text},
      mentionsSelected: [...prevState.mentionsSelected, obj],
    }));
  };

  renderIntoModal = () => {
    let { role } = this.props.user.profile;
    // console.log(this.props.user.profile.organizationId.isSetupSkipped)
    let isSetupSkipped = this.props.user.profile.organizationId.isSetupSkipped;
    let fullName;
    // console.log('pro---', profile)
    let { profile } = this.props.user;
    if (profile) {
      fullName = `${profile.firstName}`;
    } else {
      fullName = "";
    }
    if (role === "Member" || isMobile || isSetupSkipped) {
      return (
        <div className="storiesModal">
          <Modal
            className="storiesDialog"
            isOpen={this.state.showIntro}
            style={{ marginTop: "80px" }}
          >
            <ModalBody
              style={{ padding: "30px 20px 20px 5px", textAlign: "center" }}
            >
              <button
                className="onBoardingStories"
                onClick={this.closeIntroModal}
              >
                <img src={drillDownClose} height="35px" width="35px" />
              </button>

              <div className="col-md-10 onBoarding container member">
                <span
                  onClick={this.closeIntroModal}
                  className="removeOnboarding"
                >
                  <img
                    className="memberStoriesIcon"
                    src={welcomeStory}
                    style={{ margin: "0px 5px 20px" }}
                  />
                </span>
                <div> Welcome {fullName}!</div>
                <div
                  style={{
                    fontWeight: "normal",
                    fontSize: isMobile ? "12px" : "20px",
                  }}
                >
                  {staticTitles.onBoardingModal
                    .split("\n")
                    .map(function (item, idx) {
                      return (
                        <span key={idx}>
                          {item}
                          <br />
                        </span>
                      );
                    })}
                  {isMobile && <br />}
                  {/* <If condition={!isMobile}>
                    <div className="helpVidContent mt40">

                      <div className="noPadding">
                        <iframe src="https://www.youtube.com/embed/bhXR3IJNSmo?rel=0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="true"></iframe>
                      </div>
                    </div>
                  </If> */}
                  <span
                    onClick={this.closeIntroModal}
                    className="removeOnboarding"
                  >
                    {" "}
                    Go to {staticTitles.stories} →
                  </span>
                </div>
              </div>

              <div className="mt40">
                {this.state.isRemoved ? (
                  <div className="onBoardingButtons dontShowMsg">
                    <img src={"alt"} style={{ paddingRight: "5px" }} />
                    <span className="">{this.state.removedIntro}</span>
                  </div>
                ) : (
                  <div
                    className="onBoardingButtons"
                    style={{ cursor: "pointer" }}
                    onClick={this.neverShowIntro}
                  >
                    <span className="removeOnboarding">
                      {this.state.removedIntro}
                    </span>
                  </div>
                )}
              </div>
            </ModalBody>
          </Modal>
        </div>
      );
    } else if (!isSetupSkipped && role != "Member") {
      return (
        <div>
          <Modal
            className="welcomemodalparent"
            isOpen={this.state.showIntro}
            style={{ marginTop: isMobile ? "70px" : "80px" }}
          >
            <ModalBody className="storyModalBody">
              <button
                className="onBoarding-modal-close"
                onClick={this.closeIntroModal}
              >
                <img src={drillDownClose} height="35px" width="35px" />
              </button>

              <div className="col-sm-12 col-md-12">
                <div>
                  <div className="col-md-3 onBoarding container">
                    <img
                      className="onBoarding"
                      src={stories}
                      style={{ margin: "0px 5px 2px" }}
                      onClick={this.closeIntroModal}
                    />
                    {/* <Link to={'/home/stories'}><img className="onBoarding" src={stories} style={{ margin: '0px 5px 20px' }} /></Link> */}
                    <div>{staticTitles.stories}</div>
                    <span style={{ height: "50px" }}>
                      {staticTitles.cultureAppInfo}
                      <br />
                      <p
                        className="removeOnboarding"
                        onClick={this.closeIntroModal}
                      >
                        Go to {staticTitles.stories} →
                      </p>
                      {/* <Link to={'/home/stories'} className="removeOnboarding"> Go to Stories →</Link> */}
                    </span>
                  </div>

                  <div className="col-md-3 onBoarding container">
                    <Link to={"/home/my-activity"}>
                      <img
                        className="onBoarding"
                        src={ww}
                        style={{ margin: "0px 5px 20px" }}
                      />
                    </Link>

                    <div>Planning</div>
                    <span style={{ height: "50px" }}>
                      Enterprise Objectives and individual actions
                      <br />
                      <Link
                        to={"/home/my-activity"}
                        className="removeOnboarding"
                      >
                        {" "}
                        Go to Planning →
                      </Link>
                    </span>
                  </div>

                  <div className="col-md-3 onBoarding container">
                    <Link
                      to={"/home/analytics/all"}
                      onClick={this.checkRemoved}
                    >
                      <img
                        className="onBoarding"
                        src={analytics}
                        style={{ margin: "0px 5px 2px" }}
                      />
                    </Link>
                    <div>Analytics</div>
                    <span style={{ height: "50px" }}>
                      Measurements and benchmarks
                      <br />{" "}
                      <Link
                        to={"/home/analytics/all"}
                        className="removeOnboarding"
                      >
                        {" "}
                        Go to Analytics →
                      </Link>
                    </span>
                  </div>

                  <div className="col-md-3 onBoarding container">
                    <Link to={"/home/toolkit/all"}>
                      <img
                        className="onBoarding"
                        src={toolkit}
                        style={{ margin: "0px 5px 15px" }}
                      />
                    </Link>
                    <div>{staticTitles.toolkit_lg}</div>
                    <span style={{ height: "50px" }}>
                      Initiatives, resources, and recommendations
                      <br />{" "}
                      <Link
                        to={"/home/toolkit/all"}
                        className="removeOnboarding"
                      >
                        {" "}
                        Go to {staticTitles.toolkit_lg}→
                      </Link>
                      {/* Go to Analytics */}
                    </span>
                    <div className={`mt40 ${!isMobile && "positionAbsolute"}`}>
                      {this.state.isRemoved ? (
                        <div className="onBoardingButtons dontShowMsg">
                          <img
                            src={officeCreatedIcon}
                            style={{ paddingRight: "5px" }}
                          />
                          <span className="">{this.state.removedIntro}</span>
                        </div>
                      ) : (
                        <div
                          className="onBoardingButtons"
                          style={{ cursor: "pointer" }}
                          onClick={this.neverShowIntro}
                        >
                          <span className="removeOnboarding">
                            {this.state.removedIntro}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </ModalBody>
          </Modal>
        </div>
      );
    }
  };

  renderInstructions = () => {
    let { role } = this.props.user.profile;

    let { profile } = this.props.user;
    let fullName;
    // console.log('pro---', profile)

    if (this.state.profile) {
      fullName = `${profile.firstName}`;
    } else {
      fullName = "";
    }
    if (profile) {
      return this.renderIntoModal();
    }
  };

  storyTopicSelect = topic => {
    let { topicsSelected } = this.state;
    this.setState({ topicAlert: false });
    // console.log(topicsSelected, topic)
    if (topicsSelected.findIndex(x => x._id === topic._id) > -1) {
      this.setState(prevState => ({
        topicsSelected: topicsSelected.filter(e => e._id !== topic._id),
      }));
    } else {
      // console.log("topic----")
      if (topicsSelected.length < 4) {
        this.setState(prevState => ({
          topicsSelected: [...prevState.topicsSelected, topic],
        }));
      } else {
        this.setState({ topicAlert: true });
      }
    }
  };

  // renderSentimentColor=()=>{
  //   let {sentiment} = this.state
  //   console.log('color---',sentiment)
  //   if(-1.5>=sentiment) {
  //     this.setState({sentimentColor: "danger"})
  //   } else if (-1.5<sentiment<0){
  //     this.setState({sentimentColor: "warning"})
  //   } else if(0<=sentiment<=2){
  //     this.setState({sentimentColor: "info"})
  //   } else if(2<sentiment){
  //     this.setState({sentimentColor: "success"})
  //   }
  //   if(-1.5>=sentiment) {
  //     this.setState({sentimentValue:"25"})
  //   } else if (-1.5<sentiment<0){
  //     this.setState({sentimentValue:"50"})
  //   } else if(0<=sentiment<=1){
  //     this.setState({sentimentValue:"60"})
  //     return
  //   } else if(1<sentiment<=2){
  //     this.setState({sentimentValue:"75"})
  //   } else if(2<sentiment){
  //     this.setState({sentimentValue:"100"})
  //   }
  // }

  // renderSentimentValue=()=>{
  //   let {sentiment} = this.state
  //   console.log('value---',sentiment)
  //   if(-1.5>=sentiment) {
  //     this.setState({sentimentValue:"25"})
  //   } else if (-1.5<sentiment<0){
  //     this.setState({sentimentValue:"50"})
  //   } else if(0<=sentiment<=1){
  //     this.setState({sentimentValue:"60"})
  //     return
  //   } else if(1<sentiment<=2){
  //     this.setState({sentimentValue:"75"})
  //   } else if(2<sentiment){
  //     this.setState({sentimentValue:"100"})
  //   }
  // }

  renderProgress = () => {
    let { sentiment, description, isSentiment } = this.state;
    let isDesc =
      description && description.value && description.value.length == 0
        ? true
        : false;
    // console.log(sentiment, description.value)
    if (sentiment !== null && isSentiment === true) {
      sentiment = parseFloat(sentiment);
      // console.log(isDesc,'---new sent----',sentiment)
      // if(-1.5>=sentiment) {
      //   return <Progress bar color="danger" value="25"> Not that great </Progress>
      // } else if (sentiment===0 && isDesc) {
      //   return <Progress bar value="0"></Progress>
      // } else if (sentiment> -1.5 && sentiment <=1) {
      //   return <Progress bar color="warning" value="50"> Lets do better </Progress>
      // } else if(sentiment>1 && sentiment<=2.5){
      //   return <Progress bar color="info" value="75"> Nice job </Progress>
      // } else if(sentiment>2.5){
      //   return <Progress bar color="success" value="100"> Awesome </Progress>
      // }

      if (-1.5 >= sentiment) {
        return (
          <Progress bar color="danger" value="25">
            {" "}
            Not that great{" "}
          </Progress>
        );
      } else if ((sentiment === 0 && isDesc) || sentiment == 0) {
        return <Progress bar value="0"></Progress>;
      } else if (sentiment > -1.5 && sentiment <= 1) {
        return (
          <Progress bar color="warning" value="50">
            {" "}
            Lets do better{" "}
          </Progress>
        );
      } else if (sentiment > 1 && sentiment < 3) {
        return (
          <Progress bar color="info" value="75">
            {" "}
            Nice job{" "}
          </Progress>
        );
      } else if (sentiment >= 3) {
        return (
          <Progress bar color="success" value="100">
            {" "}
            Awesome{" "}
          </Progress>
        );
      }
    }
  };

  // renderSuggestion=()=>{
  //   let {suggest, description}=this.state
  //   let isDesc=description && description.value && description.value.length==0?true:false

  //   if(suggest && isDesc){
  //     return <p className="storySuggestion">{suggest.message}</p>
  //   } else {
  //     return
  //   }
  // }

  changeStoryTopic = topic => {
    let { originalStoryTotal } = this.state;
    // let {archievedStories, stories}=this.state
    // if(topic==="archived"){
    //   this.setState( prevState =>({
    //     showArchived: true,
    //     storyTopic: "archived",
    //     totalStories: archievedStories.length
    //   }))
    // }
    if (topic === "all") {
      this.setState(prevState => ({
        showArchived: false,
        storyTopic: "all",
        totalStories: originalStoryTotal,
      }));
    }
    if (topic === "trending") {
      this.props.history.push(`/home/stories/trending`);
    }
  };

  findUrl = () => {
    // console.log("find url")
  };

  closeModal = () => {
    this.setState({ showCreateStoryModal: false });
  };
  // we assign state value here for data handle purpose
  render() {
    const {
      storyType,
      description,
      suggest,
      showArchived,
      isSentiment,
      isAnonymous,
      topicsSelected,
      selectedFilter,
      filters,
      topics,
      disableSubmit,
      stories,
      collapseCompleted,
      categoryDefinitionPopoverOpen,
      archievedStories,
      showRemoveFeedConfirmationModal,
      profile,
      isFilterCollapsed,
      searchedTerm,
      Categoriesfilters,
      Tagsfilters,
      selectedCategoriesFiltercount,
      selectedTagFilterccount,
    } = this.state;

    const createStoryModalStyle = classnames(
      "profile-modal-save-btn float-left weeklyWinBtn",
      {
        disabled: disableSubmit,
        disabledBtn: disableSubmit,
      }
    );
    let fullName;

    if (this.state.profile) {
      fullName = `${profile.firstName} ${profile.lastName}`;
    }
    // console.log(this.state.description)
    return (
      <div className="stories">
        <div
          className={`ml-1 ${!isMobile && "ml-3"} text-size ${
            isMobile && "hide"
          }`}
        >
          <div className="title-text  storyTitle" style={{ display: "none" }}>
            {staticTitles.stories}

            {/* <span style={{ marginLeft: '6px' }}>({this.getStoriesCount()})</span> */}

            {
              <span>
                <span
                  id="category-definition-popover"
                  onClick={this.toggleDefinitionPopover}
                >
                  <Tooltip />
                </span>
                {
                  <Popover
                    placement="right"
                    isOpen={this.state.categoryDefinitionPopoverOpen}
                    target="category-definition-popover"
                    toggle={this.toggleDefinitionPopover}
                  >
                    <PopoverHeader className="popover-header-tooltip">
                      {staticTitles.stories}
                    </PopoverHeader>
                    <PopoverBody className="popover-body-tooltip">
                      {`Browse and share stories to find out what’s going on, learn, and contribute to a positive culture. Don’t worry, if you’re more comfortable, you can engage anonymously.`}
                    </PopoverBody>
                  </Popover>
                }
              </span>
            }

            <div
              className="storyCategoryTrending"
              onClick={() => this.changeStoryTopic("trending")}
            >
              Trending {staticTitles.storyItemsU}{" "}
              <img className="trendingIcon" src={trending} />
            </div>
          </div>

          {/* {this.props.user.profile.hideIntro !== true ?
            <IntroStoriesModal showIntro={this.state.showIntro} isRemoved={this.state.isRemoved}
            org={this.props.user.profile.organizationId}
            neverShowIntro={this.neverShowIntro} closeIntroModal={this.closeIntroModal}/>
            :
            null
          } */}

          <div className="storyCategories">
            {/* <div
          // className={this.state.url==="/"? "storyCategoryAll":"storyCategoryAll"}
          className={this.state.storyTopic==="all"?"bottomBorderHighlight storyCategoryAll":"storyCategoryAll unselectedStoryTab"}
          onClick={()=>this.changeStoryTopic("all")}
          >
           All
          </div>

          <div
          className={this.state.storyTopic==="archived"?"bottomBorderHighlight storyCategoryArchive":"storyCategoryArchive unselectedStoryTab"}
          onClick={()=>this.changeStoryTopic("archived")} >
            Archived Stories
          </div> */}

            {/* <div className="storyCategoryTrending"
          onClick={()=>this.changeStoryTopic("trending")}>
            Trending Stories <img className="trendingIcon" src={trending} />
          </div> */}
          </div>
        </div>
        {/*  Modal for creating stories  */}

        {/* {this.renderInstructions()} */}

        <Modal
          className="createStoryModalContainer"
          isOpen={this.state.showCreateStoryModal}
        >
          <CreateStoryForm
            closeModal={this.closeModal}
            storyType={storyType}
            topics={this.state.topics}
            onStoryPublish={this.onStoryPublish.bind(this)}
            onStoryCancel={this.closeCreateStoryModal.bind(this)}
          />
        </Modal>

        <Modal
          isOpen={showRemoveFeedConfirmationModal}
          className="archive-modal remove-story-model"
        >
          <ModalBody>
            <div className="modal-title">
              Remove Post
              <span
                className="model-close"
                onClick={this.closeStoryRemoveConfirmation}
              >
                <i className="flaticon-close"></i>
              </span>
            </div>
            <div className="modal-content-wrapper word-break">
              You are about to Remove a post. This action is irreversible and
              will completely delete the story. <br />
              No one, including the author of the post, will be able to see it
              any more.
            </div>
            <Row
              className="mt30 remove-story-buttons"
              style={{ marginLeft: "9px" }}
            >
              <Col sm={{ size: 4 }} md={{ size: 4 }}>
                <Button
                  className="archive-button"
                  onClick={this.removeStoryFeeds}
                >
                  Remove Post
                </Button>{" "}
              </Col>
              <If condition={!isMobile}>
                <Col sm={{ size: 4 }} md={{ size: 4 }}>
                  <Button
                    className="cancel-button float-right"
                    onClick={this.closeStoryRemoveConfirmation}
                  >
                    Cancel
                  </Button>
                </Col>
              </If>
            </Row>
          </ModalBody>
        </Modal>

        {/* <hr style={{ marginLeft: '15px', marginBottom: '30px' }} /> */}

        <div>
          {/* {(this.state.showArchived || isMobile) ?
                      null
                      :
                      <div>
                        

                        <span className="storyCategoryTrending"
                        onClick={()=>this.changeStoryTopic("trending")}>
                          Trending {staticTitles.storyItemsU} <img className="trendingIcon" src={trending} />
                      </span>

                         </div>
                            <div className="ml-3">
                            { storyTemplates.map( (e, idx)=> {
                              return (
                                <div className="col-sm-2 storyContainer" key={idx}>
                                  <div className="storyTemplate" style={{"backgroundColor":e.color, "border":e.border}} onClick={() => this.toggleCreateStory(e)}>
                                    <img src={e.image} className="templateImage"/>
                                      {e.name}
                                  </div>
                                </div>
                              )
                            })}
                      </div>
                      
                      
                     
                      
                      </div>

                    } */}

          {/* {this.state.topics && this.state.topics.length>0 ?
                       <div>


                      <Trending filters={this.state.topics} getStoryFeeds={this.getStoryFeeds} showStoryRemoveConfirmation={this.showStoryRemoveConfirmation} {...this.props}/>


                    </div>
                    :
                    null
                    } */}

          {/* 
  1. Added filter fronend filter option : search box , filter toggle option for stories filter purpuse
  2. click filter button open filter option panel, this section use to filter the stories by tags, category
  3. Toggle filter to hide
*/}
          <div>
            {!isMobile || (isMobile && isFilterCollapsed == false) ? (
              <div
                className="row p-0 m-0 mobile-search-box"
                style={{ height: "40px" }}
              >
                <div className="col-lg-9 col-md-12 col-sm-9 col-10 mb-2 searchStoriesInputContainer">
                  <InputGroup style={{ height: "40px", width: "100%" }}>
                    <Input
                      className="toolkit-field tool-search-box"
                      placeholder="Search Charts"
                      onChange={this.handleSearchQueryChanged}
                      value={searchedTerm}
                    />
                    <InputGroupAddon addonType="append">
                      <i
                        style={{ color: "#818389", padding: "7px" }}
                        className="flaticon-search"
                      ></i>
                    </InputGroupAddon>
                  </InputGroup>
                </div>

                {!isMobile ? (
                  <div className="col-lg-3 col-md-12 col-sm-12 mb-2 storiesFilterBtnContainer">
                    <Button
                      color={"secondary-filled"}
                      onClick={this.toggleCollapse}
                      style={{ marginBottom: "1rem", height: "40px" }}
                      className="filter-toggle-button"
                    >
                      <span className="tool-list-font">
                        <i
                          className="flaticon-equalizer"
                          style={{
                            fontSize: "18px",
                            marginRight: "8px",
                            color: "#3B3C41",
                          }}
                        ></i>
                        Filters{" "}
                        {selectedCategoriesFiltercount +
                          selectedTagFilterccount >
                        0 ? (
                          <span style={{ marginLeft: "4px" }}>
                            (
                            {selectedCategoriesFiltercount +
                              selectedTagFilterccount}
                            )
                          </span>
                        ) : null}
                      </span>
                    </Button>
                  </div>
                ) : (
                  <div className="col-lg-3 col-md-12 col-sm-12 mb-2">
                    <span
                      className="tool-list-font"
                      onClick={this.toggleCollapse}
                    >
                      <i
                        className="flaticon-equalizer"
                        style={{
                          fontSize: "18px",
                          marginRight: "8px",
                          color: "#3B3C41",
                        }}
                      ></i>
                      {selectedCategoriesFiltercount + selectedTagFilterccount >
                      0 ? (
                        <span style={{ marginLeft: "-36px" }}>
                          <span className="mobile-filter-count">
                            {selectedCategoriesFiltercount +
                              selectedTagFilterccount}
                          </span>
                        </span>
                      ) : null}
                    </span>
                  </div>
                )}
              </div>
            ) : null}

            {/* 
  1. listed  category list.
  2.if select a category, it will store in state and stories result return by select filter data
  3.selected category changes button color dynamically
  4.selected multiple category option added.
  5.if select all button : clear filter option and return onload stories result
*/}

            <div className="row p-0 m-0">
              {isMobile && isFilterCollapsed ? (
                <StoryFilter
                  toggleCollapseClick={this.toggleCollapse}
                  handleClearFiltersClick={() => this.handleClearFilters(true)}
                  storyTemplates={storyTemplates}
                  selectedTagFilterccount={selectedTagFilterccount}
                  Tagsfilters={Tagsfilters}
                  topics={topics}
                  selectedCategoriesFiltercount={selectedCategoriesFiltercount}
                  filters={filters}
                  filterbyTagClick={this.filterbyTag}
                  filterTopicClick={this.filterTopic}
                />
              ) : null}
              {!isMobile ? (
                <Collapse
                  isOpen={isFilterCollapsed}
                  className="col-lg-12 col-sm-12 col-md-12 pr0"
                  toggler="#toggler"
                  style={{ width: "100%" }}
                >
                  <div>
                    <div className={`stories-topics ${isMobile && "mt-2"}`}>
                      <Row>
                        <Col sm="12">
                          <div className="templatePara1"> Categories </div>
                        </Col>
                      </Row>
                      {storyTemplates && storyTemplates.length > 0 ? (
                        <div
                          className={`${!isMobile && ""} stories-topics-list`}
                        >
                          {selectedTagFilterccount > 0 ? (
                            <div className="storyGroupContainer">
                              <div
                                className="storyGroups"
                                onClick={() => this.filterbyTag("all")}
                              >
                                All
                              </div>
                            </div>
                          ) : (
                            <div className="storyGroupContainer">
                              <div className="storyGroupsSelected">All</div>
                            </div>
                          )}
                          {storyTemplates.map((tag, idx) => {
                            return (
                              <div
                                className="storyGroupContainer"
                                style={{
                                  paddingRight:
                                    tag._id == "template_other_01" ? "0px" : "",
                                }}
                                onClick={() => this.filterbyTag(tag)}
                                key={idx}
                              >
                                <div
                                  className={
                                    Tagsfilters.indexOf(tag._id) > -1
                                      ? "storyGroupsSelected"
                                      : "storyGroups"
                                  }
                                >
                                  {tag.name}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      ) : null}
                    </div>

                    {/* 
  1. listed tags.
  2.if select a tag, it will store in state and stories result return by select filter data
  3.selected tags changes button color dynamically
  4.selected multiple tags option added.
  5.if select all button : clear filter option and return onload stories resultt
*/}

                    <div className={`stories-topics ${isMobile && "mt-2"}`}>
                      <Row>
                        <Col sm="12">
                          <div className="templatePara1"> Tags </div>
                        </Col>
                      </Row>

                      {topics && topics.length > 0 ? (
                        <div
                          className={`${
                            !isMobile && "ml-3"
                          } stories-topics-list`}
                        >
                          {selectedCategoriesFiltercount > 0 ? (
                            <div className="storyGroupContainer">
                              <div
                                className="storyGroups"
                                onClick={() => this.filterTopic("all")}
                              >
                                All
                              </div>
                            </div>
                          ) : (
                            <div className="storyGroupContainer">
                              <div className="storyGroupsSelected">All</div>
                            </div>
                          )}

                          {topics.map((topic, idx) => {
                            return (
                              <div
                                className="storyGroupContainer"
                                onClick={() => this.filterTopic(topic)}
                                key={idx}
                              >
                                <div
                                  className={
                                    filters.indexOf(topic.code) > -1
                                      ? "storyGroupsSelected"
                                      : "storyGroups"
                                  }
                                >
                                  {topic.name}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      ) : null}
                    </div>
                    {/* {
  1. While click on Close Filter Button, toggleCollapse function called, it will set auto toggle function for hide filter panel
  2. While click on Clear Filter Button, handleClearFilters function called, it will clear filter related state for get stories result with out filtration
} */}
                    <div
                      className="ipad-clear-filter"
                      style={{
                        marginTop: "30px",
                        display: "flex",
                        alignItems: "center",
                        fontSize: "18px",
                        lineHeight: "25px",
                      }}
                    >
                      {!isMobile ? (
                        <Button
                          color="secondary-filled"
                          onClick={this.toggleCollapse}
                        >
                          <span
                            style={{ fontSize: "18px", lineHeight: "25px" }}
                          >
                            Close Filter
                          </span>
                        </Button>
                      ) : null}
                      <span
                        className="mobile-clear-filter"
                        style={{
                          marginLeft: "20px",
                          color: "#1679C4",
                          fontSize: "18px",
                          cursor: "pointer",
                          lineHeight: "25px",
                        }}
                        onClick={() => this.handleClearFilters(true)}
                      >
                        Clear Filters
                      </span>
                    </div>
                    <hr style={{ marginTop: "30px", marginBottom: "0px" }} />
                  </div>
                </Collapse>
              ) : null}
            </div>
          </div>
        </div>
        {/* 
  1. total stories displayed here.
  2. total stories count maintain in totalStories state.
 */}
        {isMobile && isFilterCollapsed == false ? (
          <div>
            {/* <div className="templatePara1 ml-3"> Archived {staticTitles.storyItemsU} ({this.state.totalStories}) </div> */}

            <ListGroup>{this.renderStories()}</ListGroup>
          </div>
        ) : null}
        {!isMobile ? (
          <div>
            {/* <div className="templatePara1 ml-3"> Archived {staticTitles.storyItemsU} ({this.state.totalStories}) </div> */}

            <ListGroup>{this.renderStories()}</ListGroup>
          </div>
        ) : null}
        {/* 
  1. BottomScrollListener work when page scroll function
  2. its will call handleOnDocumentBottom function for get stories results based on skip value
*/}
        <BottomScrollListener
          offset={100}
          onBottom={this.handleOnDocumentBottom}
        />

        {isMobile && <FooterBar {...this.props} />}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    subtractStoryCount: data =>
      dispatch(actionCreators.subtractStoryCount(data)),
    // addStoryCount: (data) => dispatch(actionCreators.addStoryCount(data)),
    onKpiMasterListFetched: data =>
      dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: data =>
      dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: data =>
      dispatch(actionCreators.updateProfileInfoSuccess(data)),
    resetNavBar: () => dispatch(actionCreators.navBarClear()),
    updateNavBar: header => dispatch(actionCreators.navBarUpdate(header)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Loading(Stories, axios));
